import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: 'form'
})
export class ActionFormDirective implements OnInit {
  // The purpose of this directive is to change Go button to blue on iOS devices

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.renderer.setAttribute(this.el.nativeElement, 'action', '');
  }
}
